(function () {
  "use strict";

  var e = {
    713: function _(e, t, r) {
      var _n,
          o = this && this.__extends || (_n = function n(e, t) {
        return _n = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        }, _n(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

        function r() {
          this.constructor = e;
        }

        _n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
      }),
          i = this && this.__awaiter || function (e, t, r, n) {
        return new (r || (r = Promise))(function (o, i) {
          function u(e) {
            try {
              c(n.next(e));
            } catch (e) {
              i(e);
            }
          }

          function a(e) {
            try {
              c(n.throw(e));
            } catch (e) {
              i(e);
            }
          }

          function c(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
              e(t);
            })).then(u, a);
          }

          c((n = n.apply(e, t || [])).next());
        });
      },
          u = this && this.__generator || function (e, t) {
        var r,
            n,
            o,
            i,
            u = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function a(i) {
          return function (a) {
            return function (i) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; u;) {
                try {
                  if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                  switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                    case 0:
                    case 1:
                      o = i;
                      break;

                    case 4:
                      return u.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      u.label++, n = i[1], i = [0];
                      continue;

                    case 7:
                      i = u.ops.pop(), u.trys.pop();
                      continue;

                    default:
                      if (!((o = (o = u.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                        u = 0;
                        continue;
                      }

                      if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                        u.label = i[1];
                        break;
                      }

                      if (6 === i[0] && u.label < o[1]) {
                        u.label = o[1], o = i;
                        break;
                      }

                      if (o && u.label < o[2]) {
                        u.label = o[2], u.ops.push(i);
                        break;
                      }

                      o[2] && u.ops.pop(), u.trys.pop();
                      continue;
                  }

                  i = t.call(e, u);
                } catch (e) {
                  i = [6, e], n = 0;
                } finally {
                  r = o = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, a]);
          };
        }
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var a = function (e) {
        function t(t) {
          return void 0 === t && (t = "https://mempool.space/api/v1/fees/recommended"), e.call(this, {
            baseURL: t
          }) || this;
        }

        return o(t, e), t.prototype.getFees = function () {
          return i(this, void 0, void 0, function () {
            return u(this, function (e) {
              return [2, {
                slow: {
                  fee: 11,
                  wait: 3600
                },
                average: {
                  fee: 11,
                  wait: 1800
                },
                fast: {
                  fee: 11,
                  wait: 600
                }
              }];
            });
          });
        }, t;
      }(r(846).NodeProvider);

      t.default = a;
    },
    175: function _(e, t, r) {
      var n = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.YacoinFeeApiProvider = void 0;
      var o = n(r(713));
      t.YacoinFeeApiProvider = o.default;
    },
    846: function _(e) {
      e.exports = require("@yaswap/node-provider");
    }
  },
      t = {},
      r = function r(n) {
    var o = t[n];
    if (void 0 !== o) return o.exports;
    var i = t[n] = {
      exports: {}
    };
    return e[n].call(i.exports, i, i.exports, r), i.exports;
  }(175);

  module.exports = r;
})();